import { MiscType } from './misc-data.type';

export const setPhone = (data) => ({
  type: MiscType.setPhone,
  payload: data

});

//here start
export const setConsumerProfile = (data) => ({
  type: MiscType.setConsumerProfile,
  payload: data

});

export const setFullName = (data) => ({
  type: MiscType.setFullName,
  payload: data

});

export const setBusinessName = (data) => ({
  type: MiscType.setBusinessName,
  payload: data

});

export const setAgentId = (data) => ({
  type: MiscType.setAgentId,
  payload: data

});


export const selectedConsumerList = (data) => ({
  type: MiscType.selectedConsumerList,
  payload: data

});

export const setTotalDueList = (data) => ({
  type: MiscType.setTotalDueList,
  payload: data

});


export const setBatch = (data) => ({
  type: MiscType.setBatch,
  payload: data

});


export const selectedRow = (data) => ({
  type: MiscType.selectedRow,
  payload: data

});



export const setBatchConsumers = (data) => ({
  type: MiscType.setBatchConsumers,
  payload: data

});


export const setSelectedAmount = (data) => ({
  type: MiscType.setSelectedAmount,
  payload: data

});
export const totalConsumerNo = (data) => ({
  type: MiscType.totalConsumerNo,
  payload: data

});
export const totalActiveConsumers = (data) => ({
  type: MiscType.totalActiveConsumers,
  payload: data

});

export const totalInActiveConsumers = (data) => ({
  type: MiscType.totalInActiveConsumers,
  payload: data

});

export const setStartDate = (data) => ({
  type: MiscType.setStartDate,
  payload: data

});


export const setEndDate = (data) => ({
  type: MiscType.setEndDate,
  payload: data

});


export const selectDueDate = (data) => ({
  type: MiscType.selectDueDate,
  payload: data

});



//setBatch
//here end








export const setAmount = (data) => ({
  type: MiscType.setAmount,
  payload: data

});




export const setDeviceInfo = (data) => ({
  type: MiscType.setDeviceInfo,
  payload: data

});





export const setActiveLinkStatus = (data) => ({
  type: MiscType.setActiveLinkStatus,
  payload: data

});



export const setToken = (data) => ({
  type: MiscType.setToken,
  payload: data

});


export const setAgentInfo = (data) => ({
  type: MiscType.setAgentInfo,
  payload: data

});






export const setStateDetails = (data) => ({
  type: MiscType.setStateDetails,
  payload: data

});

export const setCityList = (data) => ({
  type: MiscType.setCityList,
  payload: data

});

export const setBranchList = (data) => ({
  type: MiscType.setBranchList,
  payload: data

});

export const setIfscCode = (data) => ({
  type: MiscType.setIfscCode,
  payload: data

});



export const setBankDetails = (data) => ({
  type: MiscType.setBankDetails,
  payload: data

});

export const setSelectedBankName = (data) => ({
  type: MiscType.setSelectedBankName,
  payload: data

});


export const setSelectedBankId = (data) => ({
  type: MiscType.setSelectedBankId,
  payload: data

});

export const selectedBankDetails = (data) => ({
  type: MiscType.selectedBankDetails,
  payload: data

});




export const setBranchAddress = (data) => ({
  type: MiscType.setBranchAddress,
  payload: data

});



export const setActiveStatus = (data) => ({
  type: MiscType.setActiveStatus,
  payload: data

});


export const setLogOutWarningStatus = (data) => ({
  type: MiscType.setLogOutWarningStatus,
  payload: data

});


export const setLoginTimestamp = (data) => ({
  type: MiscType.setLoginTimestamp,
  payload: data

});




export const setGraphResponse = (data) => ({
  type: MiscType.setGraphResponse,
  payload: data

});

export const setConsumerAddresp = (data) => ({
  type: MiscType.setConsumerAddresp,
  payload: data

});


export const setBillListConsumers = (data) => ({
  type: MiscType.setBillListConsumers,
  payload: data

});

export const setBillListStartIndex = (data) => ({
  type: MiscType.setBillListStartIndex,
  payload: data

});


export const setBillListEndIndex = (data) => ({
  type: MiscType.setBillListEndIndex,
  payload: data

});

export const setBillListTotalAmount = (data) => ({
  type: MiscType.setBillListTotalAmount,
  payload: data

});

export const setBillListKeys = (data) => ({
  type: MiscType.setBillListKeys,
  payload: data

});

//add partner name
export const setPartner = (data) => ({
  type: MiscType.setPartner,
  payload: data

});

export const setRequesterId = (data) => ({
  type: MiscType.setRequesterId,
  payload: data

});

export const setLogoName = (data) => ({
  type: MiscType.setLogoName,
  payload: data

});
export const setClientRole = (data) => ({
  type: MiscType.setClientRole,
  payload: data

});
export const setTaLoadPermission = (data) => ({
  type: MiscType.setTaLoadPermission,
  payload: data

});

export const setFilterStartDate = (data) => ({
  type: MiscType.setFilterStartDate,
  payload: data

});
export const setFilterEndDate = (data) => ({
  type: MiscType.setFilterEndDate,
  payload: data

});

export const setMiscCallBackUrl = (data) => ({
  type: MiscType.setMiscCallBackUrl,
  payload: data

});


export const setClaimResp = (data) => ({
  type: MiscType.setClaimResp,
  payload: data

});

export const setRetailerBlance = (data) => ({
  type: MiscType.setRetailerBlance,
  payload: data

});


export const setClaimLoadShow = (data) => ({
  type: MiscType.setClaimLoadShow,
  payload: data

});


export const setRetailerBalanceVal = (data) => ({
  type: MiscType.setRetailerBalanceVal,
  payload: data

});

export const setDashboardPageGraphMonth = (data) => ({
  type: MiscType.setDashboardPageGraphMonth,
  payload: data

});

export const setTimeoutModal = (data) => ({
  type: MiscType.setTimeoutModal,
  payload: data

});


export const setShowAll = (data) => ({
  type: MiscType.setShowAll,
  payload: data

});

export const setService = (data) => ({
  type: MiscType.setService,
  payload: data

});

export const setLogoutEnabled = (data) => ({
  type: MiscType.setLogoutEnabled,
  payload: data

});


export const resetMiscData = {
  type: MiscType.RESET
}

